import React, { useContext, useEffect, useId, useState } from "react";
import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import CustomText from "./CustomText";
import { context } from "./accessories";
import { web } from "./Platform";

const isMobileWeb = Dimensions.get("window").width <= 480;

const Footer = (props) => {
  const { contextDetails, setContextDetails } = useContext(context),
    { iLoanId, firstActiveLoan, SessionId: iSessionId } = contextDetails,
    {
      navigate,
      From,
      iLoanId: loanId,
      UserId,
      userName,
      SessionId,
      setFloatPage = () => {},
      preventNavigation = false,
      handleClearState = () => {},
    } = props,
    [footerArray, setFooterArray] = useState([]);

  useEffect(() => {
    const iFooterArray = [
      {
        name: "Home",
        iconName: "home",
        iconSize: 25,
        navigateTo: "DashBoard",
        navigateParams: {
          flag: "changeActiveIndex",
        },
      },
      {
        name: "Docs",
        iconName: "file-text",
        iconSize: 20,
        navigateTo: loanId || iLoanId ? "Home" : "DashBoard",
        navigateParams:
          {
            loanId: loanId || iLoanId,
            Path: "Home",
            GoToNav: 9,
            FormId: 34,
          } || {},
      },
      {
        name: "Calculator",
        iconName: "calculator",
        iconSize: 20,
        navigateTo: "CalculatorMenu",
        navigateParams: {
          From,
          LoanId:
            From == "Home"
              ? contextDetails["loanId"] || 0
              : contextDetails["iLoanId"] || 0,
          UserId,
        },
      },
      {
        name: "Share",
        iconName: "share",
        iconSize: 20,
        navigateTo: "ShareApp",
        navigateParams: { From, userName },
      },
      {
        name: "Contacts",
        iconName: "address-book",
        iconSize: 20,
        navigateTo:
          (From == "Home" && contextDetails["loanId"]) ||
          (From != "Home" && contextDetails["iLoanId"])
            ? "LoanContacts"
            : "DashBoard",
        navigateParams: {
          From,
          LoanId:
            From == "Home"
              ? contextDetails["loanId"] || 0
              : contextDetails["iLoanId"] || 0,
          UserId,
          SessionId: SessionId || iSessionId,
        },
      },
    ];

    setFooterArray(iFooterArray);
  }, [props, contextDetails]);

  const handleNavigate = (path, option) => {
    let { loanId } = option;
    loanId && setContextDetails({ ...contextDetails, loanId });
    if (web && ["ShareApp", "LoanContacts", "CalculatorMenu"].includes(path)) {
      setFloatPage({ ...{ path, option } });
    } else {
      path == "DashBoard" && handleClearState();
      navigate(path, option);
    }
  };
  return (
    <View style={styles.footer}>
      {footerArray.map((navBar, index) => {
        return (
          <TouchableOpacity
            key={index}
            style={[styles.IconContainer, index === 0 ? { marginTop: -5 } : {}]}
            onPress={() => {
              if (!(preventNavigation && ["Docs"].includes(navBar["name"])))
                handleNavigate(navBar["navigateTo"], navBar["navigateParams"]);
            }}
          >
            <Icon
              name={navBar["iconName"]}
              size={navBar["iconSize"]}
              color="#999999"
              style={styles.footerIcon}
            />
            <CustomText style={[styles.footerText]}>
              {navBar["name"]}
            </CustomText>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    ...{
      height: 50,
      backgroundColor: "#f0f0f0",
      justifyContent: "space-around",
      borderTopWidth: 1,
      borderTopColor: "#ccc",
      flexDirection: "row",
    },
    ...(web && isMobileWeb
      ? { bottom: 0, position: "fixed", width: "100%" }
      : {}),
  },
  IconContainer: {
    justifyContent: "space-between",
    fontSize: 5,
    color: "#999999",
    alignItems: "center",
    paddingVertical: 5,
  },
  footerText: {
    fontSize: 12,
    justifyContent: "center",
  },
  footerIcon: {
    justifyContent: "center",
  },
});

export default Footer;
